import { Component, OnInit, ViewChild } from '@angular/core';
import { IonModal, ModalController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { VisitorChild } from '../../../models/visitorChild';
import Keyboard from 'simple-keyboard';

@Component({
  selector: 'app-add-child-modal',
  templateUrl: './add-child-modal.component.html',
  styleUrls: ['./add-child-modal.component.scss'],
})
export class AddChildModalComponent implements OnInit {

  keyboard: Keyboard;
  inputName = "fullName";
  inputs = {
    fullName: ""
  };
  addedChild: VisitorChild;
  @ViewChild(IonModal) modal: IonModal;
  // date: string | any;
  // month: string | any;
  // year: string | any;
  // dateim: string | any;
  // monthsm: string | any;
  // yearsm: string | any;
  // namem: string | any;


  constructor(private modalController: ModalController) {
  }

  ngOnInit() { }

  dismissModal() {
    this.modalController.dismiss(this.addedChild);
  }

  ngAfterViewInit() {
     this.keyboard = new Keyboard(".simple-keyboard-modal",{
      theme: "simple-keyboard hg-theme-default hg-layout-default",
      maxLength: {
        day: 2,
        month: 2,
        year: 4
        },
      inputName: this.inputName,
      onChange: (input) => this.onChange(input),
      onKeyPress: (button) => this.onKeyPress(button),
      preventMouseDownDefault: true // If you want to keep focus on input
    });

    /**
     * Since we have default values for our inputs,
     * we must sync them with simple-keyboard
     */
    this.keyboard.replaceInput(this.inputs);
  }

  onInputFocus = (event: any) => {
    this.inputName = event.target.id;

    console.log("Focused input", this.inputName);

    this.keyboard.setOptions({
      inputName: event.target.id
    });
  };

  setInputCaretPosition = (elem: any, pos: number) => {
    if (elem.setSelectionRange) {
      elem.focus();
      elem.setSelectionRange(pos, pos);
    }
  };

  onInputChange = (event: any) => {
    this.keyboard.setInput(event.target.value, event.target.id);
  };

  onChange = (input: string) => {
    this.inputs[this.inputName] = input.toUpperCase();
    console.log("Input changed", input);

    /**
     * Synchronizing input caret position
     * This part is optional and only relevant if using the option "preventMouseDownDefault: true"
     */
    let caretPosition = this.keyboard.caretPosition;

    if (caretPosition !== null)
      this.setInputCaretPosition(
        document.querySelector(`#${this.inputName}`),
        caretPosition
      );

    console.log("caretPosition", caretPosition);
  };

  onKeyPress = (button: string) => {
    console.log("Button pressed", button);

    /**
     * If you want to handle the shift and caps lock buttons
     */
    if (button === "{shift}" ) this.handleShift();
  };

  handleShift = () => {
    let currentLayout = this.keyboard.options.layoutName;
    let shiftToggle = currentLayout === "default" ? "shift" : "default";

    this.keyboard.setOptions({
      layoutName: shiftToggle
    });
  };

  addChild() {
    this.addedChild = new VisitorChild();
    this.addedChild.fullName = this.inputs.fullName;
    this.dismissModal();
  }

  cancel() {
    this.modalController.dismiss();
  }



  gotoNextField(nextElement) {
    nextElement.setFocus();
  }

}